import { createAction } from '@reduxjs/toolkit';
import { asyncActionsCreator } from '../../global/redux';
import * as constants from './constants';

export const getAllUsers = asyncActionsCreator(constants.GET_ALL_USERS);
export const clearActiveUsers = createAction(constants.CLEAR_ACTIVE_USERS);
export const updateActiveUsers = asyncActionsCreator(
  constants.UPDATE_ACTIVE_USERS
);
